import "./_content-image-slider-styles.scss";

import './view';
